import { Col, Form, Row, Select } from "antd";
import { InputCalendarioDate } from "components/input/InputCalendarioDate";
import { InputCalendarioRange } from "components/input/InputCalendarioRange";
import { SelectRota } from "components/select/SelectRota";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { RelatorioFilterProdutorTransportador } from "pages/relatorios/components/RelatorioFilterProdutorTransportador";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";
import { FAIXAS_LITRAGEM } from "./faixasLitragem";

export function FilterBarProdutorFaixaLitragem() {
	const filter = useRelatorioStore((s) => s.filter);
	const applyFilter = useRelatorioStore((s) => s.applyFilter);

	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();

	const handleFilter = (formValues: ApiRelatorioParams): void => {
		applyFilter(formValues);
	};

	return (
		<Form layout="vertical" form={formFiltroAvancado} onFinish={handleFilter}>
			<Row gutter={[10, 10]}>
				<RelatorioFilterProdutorTransportador showProdutor={true} showTransportador={false} />

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterMesRef" label="Mês Ref">
						<InputCalendarioDate
							picker="month"
							format="MM/YYYY"
							placeholder="Mês Ref."
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterMesRef: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterData" label="Data">
						<InputCalendarioRange
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterData: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterRotaIdpk" label="Rota">
						<SelectRota
							onChange={(_, rota) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterRota: rota,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterFaixasIds" label="Faixas de Litragem">
						<Select
							mode="multiple"
							allowClear={true}
							placeholder="Todas as faixas"
							options={FAIXAS_LITRAGEM.map((faixa) => ({
								label: faixa.label,
								value: faixa.id,
							}))}
							onChange={(value: string[]) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterFaixasIds: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
